import {
  reactSelectInlineError,
  getTranslatedText,
  BackgroundIcon,
  CustomModal,
  CustomMenu,
  AppContext,
  isAuthorised,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { GET_CLIENT_USERS } from '@nile/graphql/src/Query/client';
import { AccountClient, GET_CLIENT_USER_LIST } from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import Select from 'react-select';
import { FormattedMessage, injectIntl } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import NewUserContainer from '@nile/banyan/src/Containers/PageContainers/NewUserContainer';
import EditUserContainer from '@nile/banyan/src/Containers/PageContainers/EditUserContainer';
import { Modal, Avatar } from '@superops/ui-design-system';

const getIntials = (params) => {
  const initial1 = params?.firstName?.[0];
  const initial2 = params?.lastName?.[0];
  const nameInitial = params?.name?.[0];

  if (initial1 && initial2) {
    return initial1 && `${initial1}${initial2}`;
  } else {
    return initial1 || nameInitial || null;
  }
};

const ClientIconWrapper = styled.div`
  opacity: 0.6;
  margin-right: 8px;
`;

const SelectWrapper = styled.div`
  .container > div {
    border: none !important;
  }
  .Superops-Avatar__Image {
    width: 20px;
    height: 20px;
    background: #ad92fb !important;
  }
  .Superops-Avatar--hasImage {
    background: #ad92fb !important;
  }
  .container {
    margin: ${(props) => (props?.noMargin ? '0px 0px 0px 10px' : '0px 10px')};
    width: 100%;
  }
`;

const EditSheet = styled.div`
  min-width: 1000px;
  max-width: 1200px;
  &,
  .FormContainerPage {
    height: 80vh;
    border-radius: 10px;
  }
`;

const OptionButton = styled.div`
  color: rgba(1, 31, 255, 1);
`;

const UserSelectContainer = (props) => {
  const appContext = useContext(AppContext);
  const currentUserRoles = appContext.user.role.roleFeatureList;
  if (props.sortList) {
    return <SortedUserSelect {...props} currentUserRoles={currentUserRoles} />;
  }
  return <UserSelect {...props} currentUserRoles={currentUserRoles} />;
};

function UserSelect(props) {
  const [options, setoptions] = useState([]);
  const [type, setType] = useState('new');
  const [userEdited, setUserEdited] = useState(null);
  const [requesterPopupActive, setRequesterPopupActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.value);
  const {
    intl,
    updateField,
    property,
    field,
    value,
    client,
    errors,
    fetchBefore,
    icon,
    currentUserRoles,
    showEmail,
    placeholder,
    menuStyles,
    menuListStyles = {}
  } = props;
  const dropDownStyles = menuStyles || {};

  const [error, setErrors] = useState('');
  const [getClientUsers, { called, loading, data, refetch }] = useLazyQuery(
    GET_CLIENT_USERS,
    {
      client: AccountClient,
      variables: { input: { clientId: client?.accountId } }
    }
  );

  useEffect(() => {
    if (data?.getClientUserAssociationsList?.associations) {
      let users = JSON.parse(
        JSON.stringify(data?.getClientUserAssociationsList?.associations)
      );
      users = users.map((el) => {
        el = el.user;
        return {
          ...el,
          label: `${el.firstName || ''} ${el.lastName || ''}${
            showEmail ? ` <${el.email}>` : ''
          }`,
          value: `${el.firstName || ''} ${el.lastName || ''}`
        };
      });
      setoptions(users);
    }
  }, [data]);

  useEffect(() => {
    if (fetchBefore) {
      if (client?.accountId) {
        getClientUsers();
      }
    }
  }, []);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const constructDropDownError = () => {
    if (errors) {
      return reactSelectInlineError(errors);
    }
    return null;
  };

  const isAddRequesterVisible =
    isAuthorised(currentUserRoles, 'users.add') &&
    props?.createRequester &&
    client?.accountId;

  const CustomMenuWithActions = (allProps) => {
    const { innerRef, innerProps, isDisabled, children } = allProps;
    if (isAddRequesterVisible) {
      return (
        <CustomMenu
          {...allProps}
          showEmail={showEmail}
          actionComponent={
            <OptionButton
              className="ellipsis full-width cp"
              onClick={() => {
                setType('new');
                setUserEdited({});
                setRequesterPopupActive(true);
              }}
            >
              <div className="d-in-f center">
                <SVGIcon name="Add" color="rgba(1, 31, 255, 1)" />
                <div className="ml-5">
                  <FormattedMessage id="ticket.new.add.requester" />
                </div>
              </div>
            </OptionButton>
          }
        />
      );
    }
    return !isDisabled ? (
      <div
        ref={innerRef}
        {...innerProps}
        className={`customReactSelectMenu ${showEmail ? 'showEmail' : ''}`}
      >
        {children}
      </div>
    ) : null;
  };

  const onChangeField = (val) => {
    const obj = {};
    obj[property] = val[property];
    updateField(field, obj);
  };
  /* will move it async later */
  const selectedOption = props?.isMulti
    ? selectedValue
    : options.find((el) => el.userId === selectedValue?.userId);

  const updateSelectedRequester = (userData) => {
    if (client?.accountId !== userData?.associations[0]?.client?.accountId) {
      const obj = {};
      obj.accountId = userData?.associations[0]?.client?.accountId;
      updateField('client', obj);
    } else refetch();
    const obj = {};
    obj[property] = userData[property];
    updateField(field, obj);
  };

  const switchMode = (userData, mode) => {
    switch (mode) {
      case 'new':
        setType('new');
        setUserEdited({});
        break;
      default:
        setUserEdited({ ...userData });
        setType('edit');
        break;
    }
  };
  return (
    <SelectWrapper>
      {type === 'edit' ? (
        <CustomModal
          open={requesterPopupActive}
          onClose={() => setRequesterPopupActive(false)}
          // showCloseButton={true}
          // fullScreen
        >
          <EditSheet>
            <EditUserContainer
              accountId={
                userEdited?.client?.accountId ||
                userEdited?.associations[0]?.client?.accountId
              }
              id={userEdited?.user?.userId || userEdited?.userId}
              type="edit"
              newLayout
              actions={{
                back: () => setRequesterPopupActive(false),
                switchMode: switchMode,
                callback: updateSelectedRequester
              }}
            />
          </EditSheet>
        </CustomModal>
      ) : (
        <CustomModal
          open={requesterPopupActive}
          onClose={() => setRequesterPopupActive(false)}
        >
          <EditSheet>
            <NewUserContainer
              accountId={client?.accountId}
              type="new"
              newLayout
              actions={{
                back: () => setRequesterPopupActive(false),
                switchMode: switchMode,
                callback: updateSelectedRequester
              }}
              disableClientEdit={props?.disableClientEdit}
              disableSiteEdit={props?.disableSiteEdit}
            />
          </EditSheet>
        </CustomModal>
      )}
      <div className="fx center select-container">
        {icon ? (
          <ClientIconWrapper>
            <SVGIcon name="ClientLogo" />
          </ClientIconWrapper>
        ) : (
          <Avatar
            name="requesters"
            size="small"
            initials={props?.showInitials && getIntials(selectedOption)}
          />
        )}
        <div className="container">
          <Select
            onMenuOpen={() => {
              if (!selectedOption || props?.fetchOnOpen) {
                if (client?.accountId) getClientUsers();
              }
            }}
            key={selectedOption?.userId}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            value={selectedOption}
            defaultValue={props.defaultValue}
            components={{
              IndicatorSeparator,
              DropdownIndicator,
              Menu: CustomMenuWithActions
            }}
            title={getTranslatedText(intl, 'ticket.new.user')}
            onChange={onChangeField}
            options={options}
            placeholder={getTranslatedText(
              intl,
              placeholder || 'ticket.new.pl.user'
            )}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, ...menuListStyles, zIndex: 9999 }),
              menuList: (base) => ({
                ...base,
                ...dropDownStyles
              })
            }}
            noOptionsMessage={() => {
              return loading ? 'Loading...' : 'No options';
            }}
            isMulti={props?.isMulti}
            defaultMenuIsOpen={props?.defaultMenuIsOpen}
            autoFocus={props?.defaultMenuIsOpen}
            openMenuOnFocus={props?.defaultMenuIsOpen}
          />
          {constructDropDownError()}
        </div>
      </div>
    </SelectWrapper>
  );
}

function SortedUserSelect(props) {
  const [options, setoptions] = useState([]);
  const isITProduct = useProduct(COMMON_CONSTANTS.IT);
  const [type, setType] = useState('new');
  const [userEdited, setUserEdited] = useState(null);
  const [requesterPopupActive, setRequesterPopupActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.value);
  const {
    intl,
    updateField,
    property,
    field,
    value,
    client,
    site,
    department,
    errors,
    fetchBefore,
    icon,
    currentUserRoles,
    showEmail,
    menuStyles,
    menuListStyles
  } = props;
  const dropDownStyles = menuStyles || {};

  const [error, setErrors] = useState('');
  const clientCondition = { joinOperator: 'AND', operands: [] };
  const currentProduct = useProduct();
  const addCondition = (attribute, values) => {
    if (values) {
      clientCondition.operands.push({
        attribute,
        operator: 'is',
        value: values
      });
    }
  };

  if (isITProduct) {
    addCondition(
      'user.businessFunction.businessFunctionId',
      department?.businessFunctionId
    );
  } else {
    addCondition('client.accountId', client?.accountId);
  }

  if (!props?.preventSiteCondition) {
    addCondition('site.id', site?.id);
  }

  const [getClientUsers, { called, loading, data, refetch }] = useLazyQuery(
    GET_CLIENT_USER_LIST,
    {
      client: AccountClient,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'user.name',
              order: 'ASC'
            },
            condition: clientCondition.operands.length ? clientCondition : null
          }
        }
      }
    }
  );

  useEffect(() => {
    if (data?.getClientUserAssociationsList?.associations) {
      let users = JSON.parse(
        JSON.stringify(data?.getClientUserAssociationsList?.associations)
      );
      users = users.map((el) => {
        el = el.user;
        return {
          ...el,
          label: `${el.firstName || ''} ${el.lastName || ''}${
            showEmail ? ` <${el.email}>` : ''
          }`,
          value: el.userId
        };
      });
      setoptions(users);
    }
  }, [data]);

  useEffect(() => {
    if (fetchBefore) {
      if (client?.accountId || isITProduct) {
        getClientUsers();
      }
    }
  }, []);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const constructDropDownError = () => {
    if (errors) {
      return reactSelectInlineError(errors);
    }
    return null;
  };

  const isAddRequesterVisible =
    isAuthorised(currentUserRoles, 'users.add') &&
    props?.createRequester &&
    client?.accountId;

  const CustomMenuWithActions = (allProps) => {
    const { innerRef, innerProps, isDisabled, children } = allProps;
    if (isAddRequesterVisible) {
      return (
        <CustomMenu
          {...allProps}
          showEmail={showEmail}
          actionComponent={
            <OptionButton
              className="ellipsis full-width cp"
              onClick={() => {
                setType('new');
                setUserEdited({});
                setRequesterPopupActive(true);
              }}
            >
              <div className="d-in-f center">
                <SVGIcon name="Add" color="rgba(1, 31, 255, 1)" />
                <div className="ml-5">
                  <FormattedMessage id="ticket.new.add.requester" />
                </div>
              </div>
            </OptionButton>
          }
        />
      );
    }
    return !isDisabled ? (
      <div
        ref={innerRef}
        {...innerProps}
        className={`customReactSelectMenu ${showEmail ? 'showEmail' : ''}`}
      >
        {children}
      </div>
    ) : null;
  };

  const onChangeField = (val) => {
    const obj = {};
    obj[property] = val?.[property] || null;
    const additionalProps =
      isITProduct || props?.allowAdditionalProps ? { ...val } : null;
    updateField(field, obj, additionalProps);
  };
  /* will move it async later */
  const selectedOption = props?.isMulti
    ? selectedValue
    : options.find((el) => el.userId === selectedValue?.userId);

  const updateSelectedRequester = (userData) => {
    if (client?.accountId !== userData?.associations[0]?.client?.accountId) {
      const obj = {};
      obj.accountId = userData?.associations[0]?.client?.accountId;
      updateField('client', obj);
    } else refetch();
    const obj = {};
    obj[property] = userData[property];
    if (props?.allowAdditionalProps) {
      updateField(field, obj, userData);
    } else {
      updateField(field, obj);
    }
  };

  const switchMode = (userData, mode) => {
    switch (mode) {
      case 'new':
        setType('new');
        setUserEdited({});
        break;
      default:
        setUserEdited({ ...userData });
        setType('edit');
        break;
    }
  };
  return (
    <SelectWrapper noMargin={props?.noMargin}>
      {type === 'edit' ? (
        <CustomModal
          open={requesterPopupActive}
          onClose={() => setRequesterPopupActive(false)}
          // showCloseButton={true}
          // fullScreen
        >
          <EditSheet>
            <EditUserContainer
              accountId={
                userEdited?.client?.accountId ||
                userEdited?.associations[0]?.client?.accountId
              }
              id={userEdited?.user?.userId || userEdited?.userId}
              type="edit"
              newLayout
              actions={{
                back: () => setRequesterPopupActive(false),
                switchMode: switchMode,
                callback: updateSelectedRequester
              }}
            />
          </EditSheet>
        </CustomModal>
      ) : (
        <CustomModal
          open={requesterPopupActive}
          onClose={() => setRequesterPopupActive(false)}
        >
          <EditSheet>
            <NewUserContainer
              accountId={client?.accountId}
              type="new"
              newLayout
              actions={{
                back: () => setRequesterPopupActive(false),
                switchMode: switchMode,
                callback: updateSelectedRequester
              }}
              disableClientEdit={props?.disableClientEdit}
              disableSiteEdit={props?.disableSiteEdit}
            />
          </EditSheet>
        </CustomModal>
      )}
      <div className="fx center select-container">
        {!props?.hideIcon && (
          <>
            {icon ? (
              <ClientIconWrapper>
                <SVGIcon name="ClientLogo" />
              </ClientIconWrapper>
            ) : (
              <Avatar
                name="requesters"
                size="small"
                style="three"
                initials={props?.showInitials && getIntials(selectedOption)}
              />
            )}
          </>
        )}

        <div className="container">
          <Select
            onMenuOpen={() => {
              if (!selectedOption || props?.fetchOnOpen) {
                if (client?.accountId || isITProduct) getClientUsers();
              }
            }}
            key={selectedOption?.userId}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            value={selectedOption}
            defaultValue={props.defaultValue}
            components={
              props?.dropDownComponents
                ? {
                    ...props?.dropDownComponents,
                    Menu: CustomMenuWithActions
                  }
                : {
                    IndicatorSeparator,
                    DropdownIndicator,
                    Menu: CustomMenuWithActions
                  }
            }
            title={getTranslatedText(intl, 'ticket.new.user')}
            onChange={onChangeField}
            options={options}
            placeholder={
              props?.placeholder ||
              getTranslatedText(intl, 'ticket.new.pl.user')
            }
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, ...menuListStyles, zIndex: 9999 }),
              menuList: (base) => ({
                ...base,
                ...dropDownStyles
              })
            }}
            noOptionsMessage={() => {
              return loading ? 'Loading...' : 'No options';
            }}
            isClearable={props.isClearable}
            isDisabled={props.isDisabled}
            isLoading={loading}
            isMulti={props?.isMulti}
            defaultMenuIsOpen={props?.defaultMenuIsOpen}
            autoFocus={props?.defaultMenuIsOpen}
            openMenuOnFocus={props?.defaultMenuIsOpen}
          />
          {constructDropDownError()}
        </div>
      </div>
    </SelectWrapper>
  );
}

export default injectIntl(UserSelectContainer);
